import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Support from "@/pages/Support";
export const Route = createFileRoute("/support")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><Support /></ProtectedRoute>) });
